module.exports = __webpack_public_path__ + "static/media/Level.7f14de6b.png";